<div class="contact-form contact-form-inputs-underlined contact-form-button-circle mt-5">
  <form ngNoForm *ngIf="notLinked" action="/login" method="post">
    <input type="hidden" name="_token" [value]="token" />
    <input type="hidden" name="email" [value]="username" />
    <input type="hidden" name="password" [value]="password" />
    <button type="submit" class="text-uppercase font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2" appTranslate="congratulations.goToDashboard"></button>
  </form>

  <a href="/{{language}}/login" *ngIf="!notLinked" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2">
    <span class="btn-txt" appTranslate="congratulations.goToDashboard"></span>
  </a>
</div>
